import { toast } from 'vue-sonner';

export function showSuccess(title: string, description?: string): void {
  toast.success(title, {
    description,
  });
}

export function showError(title: string, description?: string): void {
  toast.error(title, {
    description,
    duration: Infinity,
    classes: {
      title: '!font-semibold',
      description: '!font-normal',
    },
    action: {
      label: 'Done',
      onClick: () => {},
    },
  });
}

export function showInfo(title: string, description?: string): void {
  toast.info(title, {
    description,
  });
}

export function showWarning(title: string, description?: string): void {
  toast.warning(title, {
    description,
  });
}
